import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/filiais";

export const Route = createFileRoute("/_authenticated/filiais")({
  head: () => ({
    meta: [
      { title: "Filiais — Milky Moo Palmares" },
      {
        name: "description",
        content: "Cadastro das filiais da empresa, com número, nome e situação de cada loja.",
      },
      { property: "og:title", content: "Filiais — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Cadastro das filiais da empresa, com número, nome e situação de cada loja.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
